export class MapsFiltrationContract{ 
    periodId: number;
    citiesIds: number[]
    dynastiesIds: number []
    constructor() {

        this.citiesIds=new Array();
        this.dynastiesIds=new Array();
    }
}